export default __webpack_public_path__ + "static/blob-02-3247b49d702c5efcc9a9ff904375f21e.svg";